module.exports = __webpack_public_path__ + "fonts/unicredit-medium.b09eb06a.woff";